import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { Toaster } from "../ui/sonner";

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-obsidian noise-overlay relative">
      <Navbar />
      <main>{children}</main>
      <Footer />
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#0F0F12',
            border: '1px solid rgba(212, 175, 55, 0.2)',
            color: '#fff',
          },
        }}
      />
    </div>
  );
};
